import React from 'react';

import './ScreenPanel.scss';

interface Props {
  title: string;
}

const ScreenPanel: React.FC<Props> = ({ title, children }) => {
  return (
    <div className="screen-panel screen-panel--active">
      <div className="screen-panel__heading">
        <h3 className="panel__title">{title}</h3>
      </div>
      <div className="screen-panel__content">{children}</div>
    </div>
  );
};

export default ScreenPanel;
